import React, {useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import {
  Modal,
} from 'react-bootstrap'
import { CitiesFilter } from "./cities-filter/CitiesFilter";
import { CitiesTable } from "./cities-table/CitiesTable";
import { CitiesGrouping } from "./cities-grouping/CitiesGrouping";
import { useCitiesUIContext } from "./CitiesUIContext";
import * as crud from "../../_redux/cities/citiesCrud";
import * as countryCrud from "../../_redux/countries/countriesCrud";
import * as stateCrud from "../../_redux/states/statesCrud";

export function CitiesCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }
 
  const navigate = useNavigate();
  const location = useLocation();
  
  let tab = "all";
  const pathParts = location.pathname.split("/");
  if (pathParts[2] === "approved" || pathParts[2] === "pending" || pathParts[2] === "rejected") {
    tab = pathParts[2];
  }

  const callFilterFunction = (val) => {
    if(val==="all")       { navigate(`/city/`); }
    if(val==="approved")  { navigate(`/city/approved`); }
    if(val==="pending")   { navigate(`/city/pending`); }
    if(val==="rejected")  { navigate(`/city/rejected`); }
  };

  const citiesUIContext = useCitiesUIContext();
  const [showcreatemodal, showCreateModal] = useState(false);
  const [name,setName] = useState('')
  const [countryId, setCountryId] = useState('')
  const [stateId, setStateId] = useState('')
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [name_is_invalid,validateName] = useState('')
  const [country_is_invalid, validateCountry] = useState('')
  const [state_is_invalid, validateState] = useState('')
  const [processing,setProcessing] = useState(false)
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])

  React.useEffect(() => {
    countryCrud.findCountries({ pageSize: 1000, pageNumber: 1, sortField: 'name', sortOrder: 'ASC' }).then(res => {
      if (res.data && res.data.entities) {
        setCountries(res.data.entities);
      }
    });
  }, []);

  const handleCountryChange = (e) => {
    const val = e.target.value;
    setCountryId(val);
    setStateId(''); // reset state
    validateCountry("");
    if (val) {
      stateCrud.findStates({ filter: { country_id: val }, pageSize: 1000, pageNumber: 1, sortField: 'name', sortOrder: 'ASC' }).then(res => {
        if (res.data && res.data.entities) {
          setStates(res.data.entities);
        }
      });
    } else {
      setStates([]);
    }
  };

  const sampleFunction = async (event,val) => {
    event.stopPropagation()
    showCreateModal(val)
  };
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const createCity = async (event) => {
    let validations_ok = true
    validateName("")
    validateCountry("")
    validateState("")
    if(name===""){
      validations_ok = false
      validateName("is-invalid");
    }
    if(countryId===""){
      validations_ok = false
      validateCountry("is-invalid");
    }
    if(stateId===""){
      validations_ok = false
      validateState("is-invalid");
    }

    if(validations_ok){
      setProcessing(true)
      await crud.createCity({
        name,
        country_id: countryId,
        state_id: stateId,
        latitude,
        longitude
      });
      await delay(1000);
      showCreateModal(false)
      setProcessing(false)
      
      // Reset form
      setName('')
      setCountryId('')
      setStateId('')
      setLatitude('')
      setLongitude('')
    }


  }
  const citiesUIProps = useMemo(() => {
    return {
      ids: citiesUIContext.ids,
      queryParams: citiesUIContext.queryParams,
      setQueryParams: citiesUIContext.setQueryParams,
      newCityButtonClick: citiesUIContext.newCityButtonClick,
      openDeleteCitiesDialog: citiesUIContext.openDeleteCitiesDialog,
      openEditCityPage: citiesUIContext.openEditCityPage,
      openUpdateCitiesStatusDialog:
        citiesUIContext.openUpdateCitiesStatusDialog,
      openFetchCitiesDialog: citiesUIContext.openFetchCitiesDialog,
    };
  }, [citiesUIContext]);
  return (
    
    <Card>
      <Modal centered show={showcreatemodal} onHide={() => showCreateModal(false)}>
          <Modal.Header >
              <Modal.Title>New City</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div className="row">
                  <div className="col-md-12 form-group mt-3">
                    <select onChange={handleCountryChange} value={countryId} className={`form-control ${country_is_invalid}`}>
                      <option value="">Select Country *</option>
                      {countries.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                    <div className="invalid-feedback">Country is required</div>
                  </div>
                  <div className="col-md-12 form-group mt-3">
                    <select onChange={event => { setStateId(event.target.value); validateState(""); }} value={stateId} className={`form-control ${state_is_invalid}`}>
                      <option value="">Select State *</option>
                      {states.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                    </select>
                    <div className="invalid-feedback">State is required</div>
                  </div>
                  <div className="col-md-12 form-group mt-3">
                    <input onChange={event => { setName(event.target.value); validateName(""); }} value={name} className={`form-control ${name_is_invalid}`} type="text" placeholder="City Name *" />
                    <div className="invalid-feedback">Name is invalid</div>
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLatitude(event.target.value)} value={latitude} className="form-control" type="text" placeholder="Latitude (Optional)" />
                  </div>
                  <div className="col-md-6 form-group mt-3">
                    <input onChange={event => setLongitude(event.target.value)} value={longitude} className="form-control" type="text" placeholder="Longitude (Optional)" />
                  </div>
              </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={(event)=>sampleFunction(event,false)} >
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={()=>createCity()} >
            { processing===true ? <i className="fas fa-circle-notch fa-spin"></i> : 'Save'}
            </button>
          </Modal.Footer>
      </Modal>
      <CardHeader title="City List">
        <CardHeaderToolbar>
        {
         (superadmin)? <button  type="button" className="btn btn-primary" onClick={(event)=>sampleFunction(event,true)} > New City </button>:<></>
        }
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <CitiesFilter />
        {citiesUIProps.ids.length > 0 && superadmin && (
          <>
            <CitiesGrouping />
          </>
        )}

        <CitiesTable />
      </CardBody>
    </Card>
  );
}
